import { StrikeProps } from './Strike.props';

const Strike = (props: StrikeProps) => {
  const { classes, enabled, isValidNumber, value } = props;

  // If the cell is not enabled but the number is valid, show the strike style.
  // The testid is the toggle hook for CFL exclusion E2E (see CashFlowLedgerPage.strikeFor):
  // its presence/absence is what `expectStrikethrough` / `expectNoStrikethrough` assert on.
  if (!enabled && isValidNumber) {
    return <span data-testid="number-checkbox-strike" className={classes.strike}>{value}</span>;
  }

  // Otherwise, just render the value
  return <span>{value}</span>;
};

export default Strike;
